export default function SearchBar({ value, onChange }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <img
        src="/images/magnifier.png"
        alt="Search"
        style={{
          position: "absolute",
          left: "1rem",
          top: "50%",
          transform: "translateY(-50%)",
          width: "32px",
          height: "32px",
          filter: "invert(70%)", // #aaa gray tone approximation
          pointerEvents: "none",
        }}
      />
      <input
        type="text"
        placeholder="Search contacts..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: "0.75rem 1rem 0.75rem 3.5rem", // space for icon
          fontSize: "1rem",
          borderRadius: "20px",
          border: "none",
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: "rgb(50 50 50)",
          color: "#fff",
        }}
      />
    </div>
  );
}